import { Ref } from '@vue/composition-api'
import { createInstance } from './axios.api'
import {
  NoticeOfInterestGenericRequest,
  NoticeOfInterestRequest
} from '@/types/notice-of-interest-page.types'
import { InterestType } from '@/types/notice-of-interest-page.types'
import { Namespace } from '@/store'
import { FieldValue } from '@/types/form.types'

export const postNoticeOfInterestGeneric = async (request: NoticeOfInterestGenericRequest):
  Promise<void> => {
  const axios = createInstance(process.env.VUE_APP_NOTICE_OF_INTEREST_GENERIC_FORM_URL)
  await axios.post('/', request)
}

export const postNoticeOfInterest = async (request: NoticeOfInterestRequest): Promise<void> => {
  const axios = createInstance(process.env.VUE_APP_NOTICE_OF_INTEREST_FORM_URL)
  await axios.post('/', request)
}

export const VALIDATION_MESSAGES = {
  address: 'Vänligen ange gatuadress dit ärendet gäller',
  zipCode: 'Vänligen ange postnummer',
  city: 'Vänligen ange postort',
  firstName: 'Vänligen ange förnamn',
  lastName: 'Vänligen ange efternamn',
  email: 'Vänligen ange epost i rätt format',
  phoneNumber: 'Vänligen ange telefonnummer med landsnummer ex. +46',
  operatorDropdown: 'Vänligen ange operatör',
  operatorInput: 'Vänligen ange operatör',
  operatorChangeDate: 'Vänligen ange leveransdatum',
  socialSecurityNumber: 'Vänligen ange personnummer i rätt format (ÅÅÅÅMMDDXXXX)'
}

export const getStoreNamespace = (interestType: string): string => {
  switch (interestType) {
    case InterestType.UPSELL:
      return Namespace.NoticeOfInterestUpsell
    case InterestType.GENERIC:
      return Namespace.NoticeOfInterestGeneric
    case InterestType.FWA:
      return Namespace.NoticeOfInterestFwa
    case InterestType.FWA_LOWBAND:
      return Namespace.NoticeOfInterestFwaLowband
    case InterestType.FWA_SITE_DEVELOPMENT:
      return Namespace.NoticeOfInterestFwaSiteDevelopment
    case InterestType.RURAL:
      return Namespace.NoticeOfInterestRural
    case InterestType.UPSELL_OPERATOR_CHANGE:
      return Namespace.NoticeOfInterestOperatorChangeUpsell
    case InterestType.NO_CAPEX:
      return Namespace.NoticeOfInterestNoCapex
    default:
      throw Error('Unknown Notice Of Interest type.')
  }
}

export const prepareNoticeOfInterestPostFields = (model: Record<string, Ref<FieldValue>>, isOperatorChange: boolean, addressId: number): NoticeOfInterestRequest => {
  return {
    FirstName: model.firstName.value as string,
    LastName: model.lastName.value as string,
    Email: model.email.value as string,
    PhoneNumber: model.phoneNumber.value as string,
    MobileNumber: model.mobileNumber.value as string,
    AddressId: addressId as number,
    ...isOperatorChange && {
      CurrentOperator: model.operatorInput.value as string || model.operatorDropdown.value as string,
      OperatorChangeDate: model.operatorChangeDate.value as string
    }
  }
}

export const prepareNoticeOfInterestGenericPostFields = (model: Record<string, Ref<FieldValue>>): NoticeOfInterestGenericRequest => {
  return {
    Address: model.address.value as string,
    ZipPostalCode: model.zipCode.value as string,
    City: model.city.value as string,
    FirstName: model.firstName.value as string,
    LastName: model.lastName.value as string,
    Email: model.email.value as string,
    PhoneNumber: model.phoneNumber.value as string,
    MobileNumber: model.mobileNumber.value as string
  }
}
